import * as React from 'react';

import './style.css';
export default function Circles(){
    
    return (
        <div id="poster-circles" className='flex-column'>
            <div className="flex-row">
                <div className="circle blue">

                </div>
                <div className="circle blue">

                </div>
            </div>
	    <div className="flex-row">
                <div className="circle blue">

                </div>
                <div className="circle blue">

                </div>
            </div>
	    <div className="flex-row">
                <div className="circle blue">

                </div>
                <div className="circle blue">

                </div>
            </div>
            <div className="flex-row">
		<div className="circle blue">

                </div>
                <div className="circle blue">

                </div>
                <div className="circle blue">

                </div>
                <div className="circle khaki">

                </div>
            </div>
        </div>
    )
}
